import * as api from 'services/api';
import { addError } from 'actions/error';

export const getReviews = (endPoint, id) => (dispatch) =>
  api.get(`${endPoint}/reviews/${id}`, 'GET_REVIEWS', dispatch).catch((error) => {
    dispatch(addError(new Error('GET_REVIEWS_ERROR')));
    return error;
  });

export const postReview = (endPoint, id, review) => (dispatch) =>
  api.post(`${endPoint}/reviews/${id}`, review, 'POST_REVIEW', dispatch).catch((error) => {
    dispatch(addError(new Error('POST_REVIEW_ERROR')));
    return error;
  });

export const deleteReview = (endPoint, reviewId) => (dispatch) =>
  api.del(`${endPoint}/reviews/${reviewId}`, 'DELETE_REVIEW', dispatch).catch((error) => {
    dispatch(addError(new Error('DELETE_REVIEW_ERROR')));
    return error;
  });
